import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import portalAxios from "../../portal/portalAxios";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { CreateReportRequest } from "../contracts/CreateReportRequest";
import { ReportCreatedResponse } from "../contracts/ReportCreatedResponse";

/** Who reports: staff with the instructor token, a member (or guardian) with the portal token. */
export type ReporterFace = "staff" | "member";

export interface ReportArgs {
  face: ReporterFace;
  request: CreateReportRequest;
}

/**
 * Reports a message or a shared material (US-111). A second report of the same item returns the first;
 * a reported message comes back to the reporter as the "Reported" row from then on.
 */
export const reportItem = createAsyncThunk<ReportCreatedResponse, ReportArgs, { rejectValue: ApiErrorResponse }>(
  "messages/report",
  async ({ face, request }, { rejectWithValue }) => {
    try {
      const { data } =
        face === "staff"
          ? await axiosInstance.post<ReportCreatedResponse>("/messaging/reports", request)
          : await portalAxios.post<ReportCreatedResponse>("/portal/messaging/reports", request);
      return data;
    } catch (error: unknown) {
      return rejectWithValue(toApiError(error, "Failed to send the report"));
    }
  },
);
